import { Col } from 'components/ui/Col'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { settingsSelectors } from 'store/settings'
import { useGetBlocks } from 'api/blocks'
import { Row } from 'components/ui/Row'
import { Icon } from 'components/ui/Icon'
import { useNavigate } from 'react-router'
import { UIButton } from 'components/ui/Button'
import { BlockCard } from 'components/blocks/BlockCard'
import { useModal } from 'providers/ModalProvider'
import { CreateBlockModal } from 'components/modal/CreateBlockModal'
import { EmptyState } from 'components/ui/EmptyState'

type BlocksListProps = {
  areaId?: string
}

export const BlocksList = ({ areaId }: BlocksListProps) => {
  const { t } = useTranslation()
  const userId = useSelector(settingsSelectors.userId)
  const { data, isLoading } = useGetBlocks({ userId, areaId })
  const navigate = useNavigate()
  const { open } = useModal()
  if (!userId) return null
  if (!areaId) return null

  const onClickGoBack = () => {
    navigate('/authenticated/areas')
  }

  const onClickCreateNote = async () => {
    open(<CreateBlockModal userId={userId} areaId={areaId} />)
  }

  return (
    <Col className={'tw-gap-2'} justifyContent={'flex-start'} alignItems={'flex-start'}>
      <Row className={'tw-gap-2'} justifyContent={'space-between'} width={'100%'} height={'2rem'}>
        <Row className={'tw-text-lg tw-font-medium tw-gap-2'} justifyContent={'flex-start'}>
          <Icon icon={['fas', 'arrow-left']} onClick={onClickGoBack} className={'tw-cursor-pointer'} />
          {t('editOrCreateNote')}
        </Row>
        <Row justifyContent={'flex-end'} className={'tw-gap-2'}>
          <UIButton
            className={'tw-w-full'}
            onClick={onClickCreateNote}
            style={{
              width: '10rem',
            }}
          >
            <Row className={'tw-gap-2'}>
              <span className={'tw-text-sm'}>{t('createNote')}</span>
              <Icon icon={['fas', 'plus']} onClick={onClickGoBack} />
            </Row>
          </UIButton>
        </Row>
      </Row>
      <Col justifyContent={'flex-start'} alignItems={'flex-start'} className={'tw-mt-2'} width={'100%'}>
        {data?.map((block) => <BlockCard key={block._id} block={block} />)}
        <EmptyState isLoading={isLoading} data={data} />
      </Col>
    </Col>
  )
}
